import { Grid, Paper, Typography, TextField, Link, Button } from '@mui/material'
import { ChangeEventHandler, FormEventHandler, useState } from 'react'

/* eslint-disable-next-line */
export interface LoginFormProps {
  onLogin: (props: {
    username: string
    password: string
    both: boolean
  }) => void
}

export function LoginForm({ onLogin }: LoginFormProps) {
  const INITIAL_STATE = {
    username: '',
    password: '',
    error: null,
  }
  // Get state variable and setState function
  const [state, setState] = useState(INITIAL_STATE)

  const handleSubmit: FormEventHandler = (event) => {
    event.preventDefault()
    onLogin({ username, password, both: true }) // TODO: we can make this user-toggleable
  }
  const handleFormChange: ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  > = (event) => {
    // Adds the changed value to the existing state
    setState({ ...state, [event.target.name]: event.target.value })
  }

  const { username, password, error } = state

  const isInvalid = password === '' || username === ''
  return (
    <Grid item sx={{ marginTop: 4 }}>
      <Paper
        variant="elevation"
        elevation={2}
        sx={{
          textAlign: 'center',
          color: (theme) => theme.palette.text.secondary,
          whiteSpace: 'nowrap',
          marginBottom: 1,
          margin: (theme) => `${theme.spacing(4)}px auto`,
          padding: 4,
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container direction="column" spacing={3}>
            {/* Card Title */}
            <Grid item>
              <Typography component="h1" variant="h5">
                SendHub Integrations Login
              </Typography>
            </Grid>

            {/* Username Field */}
            <Grid item>
              <TextField
                type="username"
                placeholder="Username"
                fullWidth
                name="username"
                variant="outlined"
                value={username}
                required
                autoFocus
                onChange={handleFormChange}
              />
            </Grid>

            {/* Password Field */}
            <Grid item>
              <TextField
                type="password"
                placeholder="Password"
                fullWidth
                name="password"
                variant="outlined"
                value={password}
                required
                onChange={handleFormChange}
                error={error !== null}
                helperText={error}
              />
            </Grid>

            {/* Forgot Password Link */}
            <Grid item container justifyContent="center">
              <Link
                style={{ display: 'table-cell' }}
                href="https://app.sendhub.com/login"
                target="_blank"
                variant="body2"
              >
                Forgot Username or Password?
              </Link>
            </Grid>

            {/* Log In Button */}
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                type="submit"
              >
                Log In
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Grid>
  )
}

export default LoginForm
